import React from "react";

export default function ModalTerms({ open, onAccept, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-lg w-full mx-4">

        <h2 className="text-2xl font-bold text-blue-800 mb-4 text-center">
          Términos y Condiciones
        </h2>

        <p className="text-gray-700 text-sm mb-4">
          Antes de iniciar la prueba, te pedimos que leas y aceptes los siguientes términos:
        </p>

        <ul className="list-disc list-inside text-gray-600 text-sm space-y-2 mb-4">
          <li>La prueba es únicamente orientativa y no constituye un diagnóstico médico.</li>
          <li>Los resultados deben ser revisados por un profesional especializado.</li>
          <li>Tu información será tratada de forma confidencial.</li>
          <li>
            El manejo de tus datos personales se realiza conforme a la
            <span className="font-semibold">
              {" "}Ley N.º 29733 – Ley de Protección de Datos Personales
            </span>{" "}
            y su Reglamento (D.S. 003-2013-JUS), garantizando consentimiento,
            finalidad, proporcionalidad y seguridad en el tratamiento de datos.
          </li>
        </ul>

        <p className="text-sm text-gray-700 mb-4">
          TEAnimo adopta medidas técnicas y organizativas para proteger tu información,
          incluyendo anonimización, cifrado y acceso restringido.
        </p>

        <p className="text-sm text-gray-700 mb-6">
          Al aceptar, confirmas que comprendes que los resultados son una guía
          y no reemplazan una evaluación profesional.
        </p>

        {/* ENLACE A TERMINOS COMPLETOS */}
        <div className="text-center mb-6">
          <a
            href="/terminos"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800 text-sm"
          >
            Ver términos y condiciones completos
          </a>
        </div>

        <div className="flex justify-between gap-4">
          <button
            onClick={onClose}
            className="w-1/2 bg-gray-300 text-gray-800 font-semibold py-2 rounded-lg hover:bg-gray-400 transition"
          >
            No Acepto
          </button>

          <button
            onClick={onAccept}
            className="w-1/2 bg-blue-600 text-white font-semibold py-2 rounded-lg hover:bg-blue-500 transition"
          >
            Acepto y Continuar
          </button>
        </div>
      </div>
    </div>
  );
}
